import { render, staticRenderFns } from "./GeografiaView.vue?vue&type=template&id=0118d67f&scoped=true"
import script from "./GeografiaView.vue?vue&type=script&lang=js"
export * from "./GeografiaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0118d67f",
  null
  
)

export default component.exports